import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import LoadingSpinner from './LoadingSpinner';

interface ProtectedRouteProps {
  component: React.ComponentType<any>;
  [key: string]: any;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ component, ...args }) => {
  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => <LoadingSpinner />,
  });
  
  return <Component {...args} />;
};

export default ProtectedRoute;